import React, { Component } from "react";
import { geolocated } from "react-geolocated";
import "./skeleton.css";
import "./normalize.css";
import "./joingig.css";

class Joingig extends Component {
  constructor() {
    super();
    this.state = {
      gigs: []
    };
    this.handleRedirect = this.handleRedirect.bind(this);
  }

  async handleRedirect(gig_id) {
    await fetch("https://symphony-api.herokuapp.com/api/join/" + gig_id, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id: window.id
      })
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          alert("You're already in a gig");
          this.props.history.push('/')
        }
      })
      .then(json => {
        this.globalData(json);
        this.props.history.push('/getgig')
      });
  }

  globalData(data) {
    window.uri = data.uri;
  }

  render() {
    return (
      <div className="container">
        <div className="j-background" />
        <div className="row">
          <div className="twelve columns">
            <div className="j-name-text">click on a gig to get started!</div>
          </div>
        </div>
        {window.gigs.map(gig => (
          <div className="row">
            <Gig gig_id={gig.id} gig_name={gig.gig_name} onRedirect={this.handleRedirect}/>
          </div>
        ))}
      </div>
    );
  }
}

class Gig extends Component {
  render() {
        return (
          <div>
            <div className="twelve columns">
              <div className="j-gig-name" onClick={(e) => this.props.onRedirect(this.props.gig_id)}>
                {this.props.gig_name}
              </div>
            </div>
          </div>
        );
      }
    
  
}

export default Joingig;


// WEBPACK FOOTER //
// ./src/joingig.js